var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"problem"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"problemitem"},[_c('p',[_vm._m(0,true),_vm._v(" "+_vm._s(item.QUESTION_TITLE)+" ")]),_c('p',[_c('span',{staticClass:"letter"},[_vm._v(" A ")]),_vm._v(" "+_vm._s(item.ANSWER)+" ")])])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"Magnifyingglass"},[_c('span',{staticClass:"circle"})])
}]

export { render, staticRenderFns }